var nl = {
  name: "nl",
  el: {
    breadcrumb: {
      label: "Breadcrumb"
    },
    colorpicker: {
      confirm: "Bevestig",
      clear: "Wissen"
    },
    datepicker: {
      now: "Nu",
      today: "Vandaag",
      cancel: "Annuleren",
      clear: "Legen",
      confirm: "Bevestig",
      selectDate: "Selecteer datum",
      selectTime: "Selecteer tijd",
      startDate: "Startdatum",
      startTime: "Starttijd",
      endDate: "Einddatum",
      endTime: "Eindtijd",
      prevYear: "Vorig jaar",
      nextYear: "Volgend jaar",
      prevMonth: "Vorige maand",
      nextMonth: "Volgende maand",
      year: "",
      month1: "januari",
      month2: "februari",
      month3: "maart",
      month4: "april",
      month5: "mei",
      month6: "juni",
      month7: "juli",
      month8: "augustus",
      month9: "september",
      month10: "oktober",
      month11: "november",
      month12: "december",
      weeks: {
        sun: "Zo",
        mon: "Ma",
        tue: "Di",
        wed: "Wo",
        thu: "Do",
        fri: "Vr",
        sat: "Za"
      },
      months: {
        jan: "jan",
        feb: "feb",
        mar: "maa",
        apr: "apr",
        may: "mei",
        jun: "jun",
        jul: "jul",
        aug: "aug",
        sep: "sep",
        oct: "okt",
        nov: "nov",
        dec: "dec"
      }
    },
    select: {
      loading: "Laden",
      noMatch: "Geen overeenkomende resultaten",
      noData: "Geen data",
      placeholder: "Selecteer"
    },
    mention: {
      loading: "Laden"
    },
    cascader: {
      noMatch: "Geen overeenkomende resultaten",
      loading: "Laden",
      placeholder: "Selecteer",
      noData: "Geen data"
    },
    pagination: {
      goto: "Ga naar",
      pagesize: "/pagina",
      total: "Totaal {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages"
    },
    messagebox: {
      title: "Bericht",
      confirm: "Bevestig",
      cancel: "Annuleren",
      error: "Ongeldige invoer"
    },
    upload: {
      deleteTip: "Kies verwijder om te wissen",
      delete: "Verwijder",
      preview: "Voorbeeld",
      continue: "Doorgaan"
    },
    table: {
      emptyText: "Geen data",
      confirmFilter: "Bevestigen",
      resetFilter: "Reset",
      clearFilter: "Alles",
      sumText: "Som"
    },
    tree: {
      emptyText: "Geen data"
    },
    transfer: {
      noMatch: "Geen overeenkomende resultaten",
      noData: "Geen data",
      titles: ["Lijst 1", "Lijst 2"],
      filterPlaceholder: "Geef zoekwoerd",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} geselecteerd"
    },
    image: {
      error: "MISLUKT"
    },
    pageHeader: {
      title: "Terug"
    },
    popconfirm: {
      confirmButtonText: "Ja",
      cancelButtonText: "Nee"
    },
    carousel: {
      leftArrow: "Carousel arrow left",
      rightArrow: "Carousel arrow right",
      indicator: "Carousel switch to index {index}"
    }
  }
};

export { nl as default };
//# sourceMappingURL=nl.mjs.map
